import script from "./NewTag.vue?vue&type=script&setup=true&lang=js"
export * from "./NewTag.vue?vue&type=script&setup=true&lang=js"

import "./NewTag.vue?vue&type=style&index=0&id=e950ee58&lang=css"

const __exports__ = script;

export default __exports__